import {useNavigate} from "react-router-dom";

export function useGoToLink() {
  let navigate = useNavigate();
  return (path: string) => navigate(path);
}
